import React from "react";

export const EMPTY_SEARCH_RESULTS = {
  lessons: { count: 0, items: [], has_next: false },
  videos: { count: 0, items: [], has_next: false },
  exercises: { count: 0, items: [], has_next: false },
  qcms: { count: 0, items: [], has_next: false },
  evaluations: { count: 0, items: [], has_next: false },
  devoirs: { count: 0, items: [], has_next: false },
  audios: { count: 0, items: [], has_next: false },
  chapitres: { count: 0, items: [], has_next: false },
};

export default function SearchDropdown({ q, results, loading, error, page, hasNext, onMore, onSelect, onClose }) {
  const resultCount = Object.values(results).reduce((total, group) => total + group.items.length, 0);
  if (!q) return null;
  if (loading && resultCount === 0) {
    return <div className="ql-search-dropdown"><div className="ql-search-empty">Recherche…</div></div>;
  }
  if (error) {
    return <div className="ql-search-dropdown"><div className="ql-search-empty">Recherche indisponible. Réessayez.</div></div>;
  }
  if (resultCount === 0) {
    return (
      <div className="ql-search-dropdown">
        <div className="ql-search-empty">
          <i className="bi bi-search me-2"></i>Aucun résultat pour « {q} »
        </div>
      </div>
    );
  }
  const Section = ({ label, icon, items, type }) => {
    if (!items.length) return null;
    return (
      <div className="ql-search-group">
        <div className="ql-search-group-label"><i className={`bi ${icon} me-1`}></i>{label}</div>
        {items.map(item => (
          <button key={item.id} className="ql-search-item" onClick={() => { onSelect(type, item); onClose(); }}>
            <span className="ql-search-type">{item.type_label}</span>
            {item.code && <span className="ql-search-code">{item.code}</span>}
            <span className="ql-search-name">{item.title}</span>
            {item.module_title && <span className="ql-search-chapter"><i className="bi bi-book me-1"></i>{item.module_title}</span>}
          </button>
        ))}
      </div>
    );
  };
  return (
    <div className="ql-search-dropdown">
      <Section label="Chapitres" icon="bi-journal-bookmark" items={results.chapitres?.items || []} type="chapter" />
      <Section label="Vidéos" icon="bi-play-circle" items={results.videos.items} type="video" />
      <Section label="Leçons" icon="bi-book" items={results.lessons.items} type="lesson" />
      <Section label="Exercices" icon="bi-pencil" items={results.exercises.items} type="exercise" />
      <Section label="QCM" icon="bi-grid" items={results.qcms.items} type="qcm" />
      <Section label="Cours audio" icon="bi-headphones" items={results.audios?.items || []} type="audio" />
      <Section label="Devoirs" icon="bi-pencil-square" items={results.devoirs?.items || []} type="devoir" />
      <Section label="Évaluations" icon="bi-clipboard-check" items={results.evaluations?.items || []} type="evaluation" />
      {hasNext && <button type="button" className="ql-search-more" disabled={loading} onClick={() => onMore(page + 1)}>{loading ? "Chargement…" : "Afficher plus"}</button>}
    </div>
  );
}
